import { render, staticRenderFns } from "./ManageAnnouncement.vue?vue&type=template&id=65f695b1&"
import script from "./ManageAnnouncement.vue?vue&type=script&lang=js&"
export * from "./ManageAnnouncement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports